/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LogDataRepresentation
 */
export interface LogDataRepresentation {
    /**
     * 
     * @type {string}
     * @memberof LogDataRepresentation
     */
    generatorKey: string;
    /**
     * 
     * @type {boolean}
     * @memberof LogDataRepresentation
     */
    isDummy: boolean;
    /**
     * 
     * @type {string}
     * @memberof LogDataRepresentation
     */
    event?: string;
    /**
     * 
     * @type {string}
     * @memberof LogDataRepresentation
     */
    originalMessageId?: string;
    /**
     * 
     * @type {string}
     * @memberof LogDataRepresentation
     */
    originalMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof LogDataRepresentation
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof LogDataRepresentation
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof LogDataRepresentation
     */
    startDate: number;
    /**
     * 
     * @type {number}
     * @memberof LogDataRepresentation
     */
    endDate?: number;
    /**
     * 
     * @type {number}
     * @memberof LogDataRepresentation
     */
    durationInSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof LogDataRepresentation
     */
    windspeed?: number;
    /**
     * 
     * @type {number}
     * @memberof LogDataRepresentation
     */
    prodLoss?: number;
}

/**
 * Check if a given object implements the LogDataRepresentation interface.
 */
export function instanceOfLogDataRepresentation(value: object): value is LogDataRepresentation {
    if (!('generatorKey' in value) || value['generatorKey'] === undefined) return false;
    if (!('isDummy' in value) || value['isDummy'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function LogDataRepresentationFromJSON(json: any): LogDataRepresentation {
    return LogDataRepresentationFromJSONTyped(json, false);
}

export function LogDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'generatorKey': json['generatorKey'],
        'isDummy': json['isDummy'],
        'event': json['event'] == null ? undefined : json['event'],
        'originalMessageId': json['originalMessageId'] == null ? undefined : json['originalMessageId'],
        'originalMessage': json['originalMessage'] == null ? undefined : json['originalMessage'],
        'color': json['color'] == null ? undefined : json['color'],
        'description': json['description'] == null ? undefined : json['description'],
        'startDate': json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'durationInSeconds': json['durationInSeconds'] == null ? undefined : json['durationInSeconds'],
        'windspeed': json['windspeed'] == null ? undefined : json['windspeed'],
        'prodLoss': json['prodLoss'] == null ? undefined : json['prodLoss'],
    };
}

export function LogDataRepresentationToJSON(json: any): LogDataRepresentation {
    return LogDataRepresentationToJSONTyped(json, false);
}

export function LogDataRepresentationToJSONTyped(value?: LogDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generatorKey': value['generatorKey'],
        'isDummy': value['isDummy'],
        'event': value['event'],
        'originalMessageId': value['originalMessageId'],
        'originalMessage': value['originalMessage'],
        'color': value['color'],
        'description': value['description'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'durationInSeconds': value['durationInSeconds'],
        'windspeed': value['windspeed'],
        'prodLoss': value['prodLoss'],
    };
}

